module.exports = __webpack_public_path__ + "static/media/image22.5143729e.jpg";